export default "__VITE_ASSET__BLqNpJbX__"